import { AxiosResponse } from "axios";
import axiosInstance from "../../../../../api/axios";

export const getProjectPayload = (formikData: any) => {
    console.log(formikData);
    const form = formikData[1]
    const apiData: any = {
        // Step 1
        name: form.name,
        sponsor: form.sponsor,
        last_revised: form.lastRevised,
        project_start_date: form.startDate,
        team_members: form.teamMembers.map((member: any) => ({
            name: member.fullName,
            role: member.role,
            code: member.code,
        })),
        // Technical area, department, and facility
        technical_area_id: 2,
        department_id: 1,
        facility_id: 1, // You need to provide this value
        stage: 1
    };

    // Validate and add problem_statement only if all required fields exist
    if (
        formikData[2]
    ) {
        const form = formikData[2];
        apiData.problem_statement = {
            effect: form.effect,
            what: form.problem,
            where: form.whereDoesTheProblemExist,
            who: "string",
            magnitude: form.magnitude,
            unit_of_measure: form.unitOfMeasure,
            from: form.from,
            to: form.to,
            complete_statement: form.problemStatement
        };
        apiData.stage = 2;
    }

    // Validate and add aim_statement only if all required fields exist
    if (
        formikData[3]
    ) {
        const form = formikData[3];
        apiData.aim_statement = {
            qit_name: form.qitName,
            project_aim: form.aim,
            baseline_magnitude: form.baselineMagnitude,
            unit_of_measure_baseline: form.baselineMagnitudeUnitOfMeasure,
            target_magnitude: form.targetMagnitude,
            unit_of_measure_target: form.targetMagnitudeUnitOfMeasure,
            from: form.from,
            to: form.to,
            complete_statement: form.aimStatement
        };
        apiData.stage = 3;
    }
    if (
        formikData[4]
    ) {
        const form = formikData[4];
        apiData.causes = getCausePayload(form.causes);
        apiData.stage = 4;
    }

    return apiData;
};

export const createProject = async (values: any) => {
    try {
        const response: AxiosResponse<any> = await axiosInstance.post(`/project`, values);
        console.log('Create successful:', response.data);
        return {
            data: response.data,
            success: true,
            message: 'Project created successfully'
        };
    } catch (error: any) {
        console.error('Project creation failed:', error.response?.data || error.message);
        return {
            data: null,
            success: false,
            message: error.response?.data || error.message
        }
    }
}

export const getProject = async (ProjectId: number) => {
    try {
        const response: AxiosResponse<any> = await axiosInstance.get(
            `/Project/${ProjectId}`
        );
        console.log("get successful:", response.data);
        return response.data;
    } catch (error: any) {
        console.error("get failed:", error.response?.data || error.message);
        return null;
    }
};
export const getAimStatement = (qitName: string, to: string, aim: string,
    from: string,
) => {
    return `I/we, (qitName), aim to (aim) (problem) from (from) to (to)`
        .replace("(qitName)", `${qitName} to ${to?.split("T")[0]}`)
        .replace("(aim)", aim || "")
        .replace("(problem)", aim || "")
        .replace("(from)", from?.split("T")[0] || "")
        .replace("(to)", to?.split("T")[0] || "");
};

export const getCausePayload = (causes: any) => {
    let payLoads: { name: any; category: any; sub_causes: any; }[] = []
    causes.forEach((cause: any) => {
        return cause.primaryCauses.forEach((primaryCause: any) => {
            payLoads.push({
                "name": primaryCause.primary,
                "category": cause.category,
                "sub_causes": primaryCause.secondaryCauses.map((secondaryCause: any) => {
                    return {
                        "name": secondaryCause,
                    }
                })
            })
        })
    })
    return payLoads
};